import React from 'react';

const PilotIcon = (props) => {
  return (
    <svg
      width="39"
      height="28"
      viewBox="0 0 39 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_8_3116)">
        <path
          d="M2.28564 12C2.28564 5.37258 7.65823 0 14.2856 0H24.2856C30.9131 0 36.2856 5.37258 36.2856 12V12C36.2856 18.6274 30.9131 24 24.2856 24H14.2856C7.65823 24 2.28564 18.6274 2.28564 12V12Z"
          fill={props.color}
          shapeRendering="crispEdges"
        />
        <path
          d="M26.0356 15V13.5L20.0356 9.75V5.625C20.0356 5.0025 19.5331 4.5 18.9106 4.5C18.2881 4.5 17.7856 5.0025 17.7856 5.625V9.75L11.7856 13.5V15L17.7856 13.125V17.25L16.2856 18.375V19.5L18.9106 18.75L21.5356 19.5V18.375L20.0356 17.25V13.125L26.0356 15Z"
          fill="black"
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_8_3116"
          x="0.285645"
          y="0"
          width="38"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8_3116"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8_3116"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default PilotIcon;
